// App.tsx
import React, { useEffect, useState } from 'react';
import ChatPopup from './ChatPopup';
import { MdAdd } from 'react-icons/md';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import ChatGPTIcon from '../../../../../assets/img/chatgpt/gpticon2.png';
import { HashLoader } from 'react-spinners';
import {
  Box,
  Text,
  Flex,
  Button,
  Icon,
  List,
  ListItem,
  Img,
  useToast,
  Divider,
  Tooltip,
} from '@chakra-ui/react';
import { getChats, storeChat } from 'utils/translatechatgpt/translate';
import { useParams } from 'react-router-dom';
// import { GPT_API_KEY } from 'config/constant';
import { ChatGPtResponse,getChatgptKey } from 'utils/game/gameService';
interface ChatButtonProps {
  setChatNote: any;
  chatNote: any;
}

// const API_KEY = 'sk-qCVjoAh4cAvXmoTZjWjbh0WTs-arVyZmT1nVwrndfBT3BlbkFJNVDsdzR_RAXLvtLaHTT0pxQSRoa82xsm67kV8ajQYA';
// const API_KEY = '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';
// const API_KEY = GPT_API_KEY;
const ChatButton: React.FC<ChatButtonProps> = ({ setChatNote, chatNote }) => {
    // const [API_KEY, setApiKey] = useState<string | null>(null);
  const [showChat, setShowChat] = useState<boolean>(false);
  const [messages, setMessages] = useState<any[]>([
    {
      message: "Hello, I'm ChatGPT! Ask me anything!",
      sentTime: 'just now',
      sender: 'ChatGPT',
      hidden: false,
    },
  ]);
  const [loading, setLoading] = useState(false);

  const fetchMessage = async () => {
    const resp = await getChats(id);

    if (resp?.status === 'Success' && resp?.data.length !== 0) {
      const fetchedMessages = resp.data.map((msg: any) => ({
        ...msg,
        fromStoryForm: msg.fromStoryForm || false,
        hidden: false, // or msg.hidden if saved
      }));
      setMessages((prev) => [...prev, ...resp?.data]);
      setShowGpt(true);
    }
  };
  useEffect(() => {
    fetchMessage();
  }, []);

  const { id, val } = useParams();
  const [isTyping, setIsTyping] = useState<boolean>(false);
  const [showGpt, setShowGpt] = useState(false);
  const toast = useToast();
//   useEffect(() => {
//   const fetchKey = async () => {
//     try {
//       const data = await getChatgptKey(); // ✅ already parsed JSON
//       setApiKey(data.key); // set API_KEY from backend
//     } catch (err) {
//       console.error("Error fetching key:", err);
//     }
//   };
//   fetchKey();
// }, []);
  
    // console.log("API_KEY in state:", API_KEY);
  const handleSendRequest = async (message: string, hidden: boolean) => {
    const newMessage = {
      message,
      direction: 'outgoing',
      sender: 'user',
      hidden: hidden,
      fromStoryForm: hidden,
    };
    const lmsChat = {
      chGameId: id,
      chRole: 'user',
      chMessage: message,
      fromStoryForm: newMessage.fromStoryForm || false,
      chatgpt: true,
    };
    const data = JSON.stringify(lmsChat);

    if (!hidden) {
      const resp = await storeChat(data);
      if (resp?.status === 'Success') {
        setMessages((prevMessages) => [...prevMessages, newMessage]);
      }
    } else {
      setMessages((prevMessages) => [...prevMessages, newMessage]);
    }
    setIsTyping(true);

    try {
      const response = await processMessageToChatGPTs([...messages, newMessage]);
      console.log(response,'responseinneway')
      const content = response;
      console.log(content,'content')
      if (content) {
        const chatGPTResponse = {
          message: content,
          sender: 'ChatGPT',
          hidden: false,
          fromStoryForm: newMessage.fromStoryForm || false,
          type: newMessage.fromStoryForm ? 'storyForm' : undefined,
        };
        const lmsChat = {
          chGameId: id,
          chRole: 'ChatGPT',
          chMessage: content,
          chatgpt: true,
          type: newMessage.fromStoryForm ? 'storyForm' : undefined,
        };
        const data = JSON.stringify(lmsChat);
        const resp = await storeChat(data);
        if (resp?.status === 'Success') {
          setMessages((prevMessages) => [...prevMessages, chatGPTResponse]);
          setChatNote(content);
        }
      }
    } catch (error) {
      console.error('Error processing message:', error);
      toast({
        title: 'Something went wrong.',
        description: 'Please try again later.',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top',
      });
      console.error('Error processing message:', error);
    } finally {
      setIsTyping(false);
    }
  };


  async function processMessageToChatGPTs(chatMessages: any[]) {
    // Adjust the type based on your actual message structure
    const apiMessages = chatMessages.map((messageObject) => {
      const role = messageObject.sender === 'ChatGPT' ? 'assistant' : 'user';
      return { role, content: messageObject.message };
    });

    const trimmedMessages = apiMessages.slice(-5);

    const apiRequestBody = {
      model: 'gpt-4.1-2025-04-14',
      messages: trimmedMessages,
    };
const newapiRequestBody= JSON.stringify(apiRequestBody)
console.log(newapiRequestBody,'newapiRequestBody')
    const response = await getChatgptKey(newapiRequestBody) 
     console.log(response,'responsedata')
    const data = response.choices[0]?.message?.content
 
console.log(data,'dataresponse')
    return data;
    // const response = await getChatgptKey(newapiRequestBody)
    // console.log(response,'responseingpt')
    // return response()
  }
  const handleCloseChat = () => {
    setShowChat(false);
  };
  return (
    <div className="App">
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      {showChat && (
        <ChatPopup
          messages={messages}
          isTyping={isTyping}
          onSend={handleSendRequest}
          onClose={handleCloseChat}
          setShowGpt={setShowGpt}
          showGpt={showGpt}
          setMessages={setMessages}
          setChatNote={setChatNote}
          chatNote={chatNote}
          setShowChat={setShowChat}
          showChat={showChat}
          loading={loading}
          setLoading={setLoading}
        />
      )}
      <Box
        position="fixed"
        bottom={{ base: '105px', xl: '20px' }}
        right={{ base: '12px', xl: '20px' }}
      >
        <Tooltip hasArrow label="Ask From ChatGPT" placement="top-start">
          <div>
            <Button
              bg={'#279b7e'}
              _hover={{
                transform: 'translateY(-2px)', // Apply a slight upward translation on hover
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              }}
              color={'#fff'}
              mr={'10px'}
              w="50px"
              h="50px"
              className="showFormBox"
              onClick={() => setShowChat(!showChat)}
            >
              <Img
                src={ChatGPTIcon}
                style={{ height: '30px', maxWidth: '30px' }}
              />
            </Button>
          </div>
        </Tooltip>
      </Box>
    </div>
  );
};

export default ChatButton;
